import React from "react";
import { useUI } from "@/context/UIContext";
import { Play, Plus, Check, Star } from "lucide-react";

export function ContentCard({ item, rank }) {
  const { openDetail, myListIds, toggleMyList } = useUI();
  const inList = myListIds.has(item.id);
  const isLive = item.type === "live";

  return (
    <div className={`relative shrink-0 ${rank ? "flex items-end" : ""}`}>
      {rank && (
        <span className="rank-number text-[7rem] md:text-[9rem] mr-[-1.2rem] select-none">{rank}</span>
      )}
      <div
        data-testid="content-card-item"
        onClick={() => openDetail(item)}
        className="group relative w-[150px] sm:w-[170px] md:w-[190px] aspect-[2/3] rounded-lg overflow-hidden cursor-pointer card-hover bg-[#121824] border border-white/5"
      >
        <img src={item.poster} alt={item.title} loading="lazy" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0B0E14] via-transparent to-transparent opacity-70" />

        {item.is_original && (
          <span className="absolute top-2 left-2 text-[9px] font-bold tracking-wider px-1.5 py-0.5 rounded bg-[var(--nik-gold)] text-black">KALAMPRIME</span>
        )}
        {isLive && (
          <span className="absolute top-2 left-2 flex items-center gap-1 text-[9px] font-bold tracking-wider px-1.5 py-0.5 rounded bg-[var(--nik-live)] text-white">
            <span className="w-1.5 h-1.5 rounded-full bg-white live-dot" /> LIVE
          </span>
        )}

        <div className="absolute inset-x-0 bottom-0 p-2.5 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="text-sm font-semibold text-white line-clamp-1">{item.title}</div>
          <div className="flex items-center gap-2 mt-1 text-[10px] text-slate-300">
            {item.match > 0 && <span className="text-[var(--nik-glow)] font-bold font-mono">{item.match}% Match</span>}
            <span className="border border-white/30 px-1 rounded">{item.rating}</span>
            <span>{item.year}</span>
          </div>
          <div className="flex items-center gap-2 mt-2">
            <button className="w-7 h-7 rounded-full bg-white text-black flex items-center justify-center hover:scale-110 transition-transform">
              <Play size={13} fill="currentColor" />
            </button>
            <button
              onClick={(e) => { e.stopPropagation(); toggleMyList(item); }}
              data-testid={`card-mylist-${item.id}`}
              className="w-7 h-7 rounded-full border border-white/40 text-white flex items-center justify-center hover:border-white bg-black/40"
            >
              {inList ? <Check size={13} /> : <Plus size={13} />}
            </button>
          </div>
        </div>

        {typeof item.progress === "number" && item.progress > 0 && (
          <div className="absolute bottom-0 inset-x-0 h-1 bg-white/20">
            <div className="h-full bg-[var(--nik-blue)]" style={{ width: `${item.progress}%` }} />
          </div>
        )}
      </div>
    </div>
  );
}
